import {ProfileApplicationsItem} from '../../../../common/applications/item';
import {Modal} from '../../../../../../shared/components/modal/modal';
import * as React from 'react';
import {IStateProps} from './model';
import {useStyles} from '../../../../../../shared/hooks/styles';

export default ({onClose, application}: IStateProps) => {
  const style = useStyles(() => ({
    modalWrap: {
      width: 800,
      paddingTop: 0,
      paddingHorizontal: 75,
    },
    modalContent: {
      paddingTop: 30,
    },
  }));

  return (
    <Modal contentStyle={style.modalContent} wrapStyle={style.modalWrap} onClose={onClose}>
      <ProfileApplicationsItem application={application} />
    </Modal>
  );
};
